import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-4 text-brand-text leading-relaxed" data-id="element-27">
    <p className="text-sm text-brand-muted" data-id="element-28">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-29">
      1. Información que recopilamos
    </h3>
    <p data-id="element-30">
      Al adquirir "IA Fácil y Práctica", recopilamos únicamente los datos
      necesarios para procesar tu compra y entregarte el producto digital:
      nombre, correo electrónico e información de pago (procesada de forma
      segura por nuestra pasarela de pagos).
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-31">
      2. Uso de tu información
    </h3>
    <p data-id="element-32">
      Tus datos se utilizan exclusivamente para: (a) entregarte el eBook y
      materiales asociados, (b) enviarte el comprobante de compra, y (c)
      brindarte soporte si lo solicitas. No vendemos, alquilamos ni compartimos
      tu información con terceros con fines comerciales.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-33">
      3. Cookies y análisis
    </h3>
    <p data-id="element-34">
      Utilizamos cookies básicas para mejorar tu experiencia de navegación y
      herramientas de análisis anónimas para entender cómo se usa nuestro sitio.
      Puedes desactivar las cookies desde tu navegador en cualquier momento.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-35">
      4. Seguridad
    </h3>
    <p data-id="element-36">
      Empleamos medidas de seguridad estándar de la industria para proteger tu
      información. Los pagos se procesan a través de proveedores certificados
      PCI-DSS, por lo que nunca almacenamos los datos de tu tarjeta.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-37">
      5. Tus derechos
    </h3>
    <p data-id="element-38">
      Tienes derecho a acceder, rectificar o eliminar tus datos personales.
      También puedes solicitar la portabilidad de tu información o retirar tu
      consentimiento en cualquier momento.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-39">
      6. Menores de edad
    </h3>
    <p data-id="element-40">
      Este producto está dirigido a adultos (padres, profesores y educadores).
      No recopilamos intencionalmente datos de menores de edad.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-41">
      7. Cambios en esta política
    </h3>
    <p data-id="element-42">
      Podemos actualizar esta política periódicamente. Cualquier cambio
      relevante será notificado a través de nuestro sitio web.
    </p>
  </div>;
const termsContent = <div className="space-y-4 text-brand-text leading-relaxed" data-id="element-43">
    <p className="text-sm text-brand-muted" data-id="element-44">
      Última actualización:{' '}
      {new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-45">
      1. Aceptación de los términos
    </h3>
    <p data-id="element-46">
      Al adquirir y utilizar "IA Fácil y Práctica: El Manual de Supervivencia
      Educativa", aceptas estos Términos de Servicio en su totalidad. Si no
      estás de acuerdo con alguna parte, te pedimos no realizar la compra.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-47">
      2. Naturaleza del producto
    </h3>
    <p data-id="element-48">
      El producto es un material digital descargable en formato PDF. La entrega
      es inmediata tras la confirmación del pago, mediante un enlace de descarga
      enviado al correo electrónico proporcionado.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-49">
      3. Licencia de uso
    </h3>
    <p data-id="element-50">
      Al comprar el eBook obtienes una licencia personal e intransferible para
      uso individual o dentro de tu núcleo familiar/aula. No está permitido
      revender, redistribuir, copiar masivamente, ni publicar el contenido total
      o parcial sin autorización escrita.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-51">
      4. Propiedad intelectual
    </h3>
    <p data-id="element-52">
      Todo el contenido (texto, plantillas, dinámicas, gráficos y diccionario)
      está protegido por derechos de autor y es propiedad exclusiva de "IA Fácil
      y Práctica". Los logos y marcas mencionadas pertenecen a sus respectivos
      dueños.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-53">
      5. Política de reembolsos
    </h3>
    <p data-id="element-54">
      Por tratarse de un producto digital de descarga inmediata, todas las
      ventas son finales. Si experimentas un problema técnico que impida acceder
      al material, evaluaremos cada caso de forma individual.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-55">
      6. Limitación de responsabilidad
    </h3>
    <p data-id="element-56">
      El contenido del manual tiene fines educativos. No garantizamos resultados
      específicos, ya que estos dependen de la aplicación práctica del lector.
      No nos hacemos responsables del uso indebido de las herramientas de IA
      mencionadas.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-57">
      7. Herramientas de terceros
    </h3>
    <p data-id="element-58">
      El manual hace referencia a herramientas de IA externas (ChatGPT,
      Perplexity, etc.). Estas son administradas por terceros y se rigen por sus
      propios términos. No tenemos control sobre su disponibilidad, precios o
      políticas.
    </p>

    <h3 className="font-heading font-bold text-lg text-brand-dark" data-id="element-59">
      8. Modificaciones
    </h3>
    <p data-id="element-60">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones entrarán en vigor desde su publicación en este
      sitio.
    </p>
  </div>;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  useEffect(() => {
    if (type) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [type]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  const title = type === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio';
  const content = type === 'privacy' ? privacyContent : termsContent;
  return <AnimatePresence data-id="element-61">
      {type && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} onClick={onClose} className="fixed inset-0 z-[100] bg-brand-dark/60 backdrop-blur-sm flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-62">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="bg-white rounded-3xl shadow-soft-lg w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-63">
            <div className="flex items-center justify-between p-6 border-b border-cream-200 shrink-0" data-id="element-64">
              <h2 id="modal-title" className="font-heading font-bold text-2xl text-brand-dark" data-id="element-65">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="text-brand-muted hover:text-brand-dark hover:bg-cream-100 p-2 rounded-full transition-colors" data-id="element-66">
                <X size={20} data-id="element-67" />
              </button>
            </div>
            <div className="overflow-y-auto p-6 md:p-8" data-id="element-68">{content}</div>
            <div className="p-4 border-t border-cream-200 shrink-0 bg-cream-50 flex justify-end" data-id="element-69">
              <button onClick={onClose} className="bg-brand-blue hover:bg-brand-blueHover text-white px-5 py-2 rounded-full font-semibold text-sm transition-colors" data-id="element-70">
                Cerrar
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [modal, setModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-white border-t border-cream-200 py-12 px-4 sm:px-6 lg:px-8 mt-auto" data-id="element-71">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-72">
          <div className="flex items-center gap-2 opacity-80" data-id="element-73">
            <div className="bg-brand-blue text-white p-1.5 rounded-lg" data-id="element-74">
              <BookOpen size={18} data-id="element-75" />
            </div>
            <span className="font-heading font-bold text-lg text-brand-dark" data-id="element-76">
              IA Fácil y Práctica
            </span>
          </div>

          <div className="text-sm text-brand-muted text-center md:text-left" data-id="element-77">
            © {new Date().getFullYear()} IA Fácil y Práctica. Todos los
            derechos reservados.
          </div>

          <div className="flex gap-6 text-sm text-brand-muted" data-id="element-78">
            <button onClick={() => setModal('privacy')} className="hover:text-brand-blue transition-colors cursor-pointer" data-id="element-79">
              Política de Privacidad
            </button>
            <button onClick={() => setModal('terms')} className="hover:text-brand-blue transition-colors cursor-pointer" data-id="element-80">
              Términos de Servicio
            </button>
          </div>
        </div>
      </footer>

      <Modal type={modal} onClose={() => setModal(null)} data-id="element-81" />
    </>;
}